module.exports = __webpack_public_path__ + "static/media/ic_categories_cosmetics.95f2a778.svg";